module.exports = __webpack_public_path__ + "static/kobe-6-5a281754ae4ff72b48842bf31f556b67.jpg";